import React, { useState, useEffect } from "react";
import ScheduleWeeks from "./ScheduleWeeks";
import DayList from "./DayList";
import LectureList from "./LectureList";
import { GetSchedule } from "./API";
import { Route, Link } from "react-router-dom";
import { Translate } from 'react-localize-redux';

const DetailedSchedule = props => {
  const selectDay = dayName => {
    setSelectedDay(dayName);
  };
  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState("Saturday");

  useEffect(() => {
    GetSchedule(
      props.match.params.weekNo === undefined ? "0" : props.match.params.weekNo
    ).then(data => {
      console.log(data);
      setDays(data.days);
    });
  }, [props.match.params.weekNo]);
  return (
    <React.Fragment>
      <div class="card card-bottom-tabs">
        <div class="card-block">
          <h4 class="card-title m-t-0"><Translate id="general.Weeks"/></h4>
          <ScheduleWeeks />
        </div>
      </div>
      <div class="row  no-gutters m-t-10">
        <DayList selectDay={selectDay} days={days} />
        <LectureList selectedDay={selectedDay} days={days} />
      </div>
    </React.Fragment>
  );
};

export default  DetailedSchedule;



// WEBPACK FOOTER //
// ./src/pages/student_schedule/DetailedSchedule.js